<template>
    <div>
        <HeaderBg title="التقارير" />

        
    </div>
</template>
<script>
import HeaderBg from '../../global/HeaderBg/HeaderBg';
export default {
    name: 'Reports',
    components: {HeaderBg},
    data(){
        return{

        }
    },
    mounted(){
    },
   
}
</script>
<style lang="scss" scoped>

</style>